import { css, styled } from 'styled-components';

interface ActionWrapperProps {
    $iconOnly?: boolean;
}

export const ActionWrapper = styled.div<ActionWrapperProps>`
    min-width: 140px;

    ${({ $iconOnly }) =>
        $iconOnly &&
        css`
            min-width: unset;
        `};

    > button {
        width: 100%;
    }
`;
